import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid } from '@mui/material';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import CkeditorField from '../../../../components/inputs/CkeditorField';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BTextField from '../../../../components/inputs/forms/BTextField';
import BTextareaField from '../../../../components/inputs/forms/BTextareaField';
import { setValues, onChangeForBComponents } from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';

const initialItem = {
  name: '',
  name_fa: '',
  keywords: '',
  description: '',
  content: '',
  display: true,
  test: 'test',
  image: null,
};
const url = process.env.REACT_APP_SITE_URL;
const cookies = new Cookies();

const BlogPage = (props) => {
  const navigate = useNavigate();
  const { staticContext, ...rest } = props;
  const { globalState, saveItem } = useContext(DashboardPanelContext);
  const [textEditor, setTextEditor] = useState('');
  const { viewReadOnly } = globalState;

  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue } = useForm();
  const [coverImage, setCoverImage] = useState(null);

  const {
    id,
    item: currentItem,
    setItem: setCurrentItem,
  } = useBasicInformationMountedEffect({
    match: { params: props.param },
    fetchItemURL: '/blogs',
    localStorageKey: 'blogs',
    initialItem,
  });

  const fileSelectedHandlerLoadImage = async (e) => {
    setCoverImage(null);
    const name = url.concat(e);
    const imgSrc = `${name}?w=164&h=164&fit=crop&auto=format`;
    // eslint-disable-next-line no-shadow
    setCoverImage({ img: imgSrc });
  };

  useEffect(() => {
    if (currentItem.data) {
      setCurrentItem(currentItem.data);
    }
    if (currentItem) {
      setValues(setValue, currentItem);
    }
    if (currentItem.id) {
      currentItem.test = 'test';
    }
    if (currentItem?.id && currentItem.attachments && currentItem.attachments[0]) {
      if (currentItem.attachments[0].slug === 'image') {
        fileSelectedHandlerLoadImage(currentItem.attachments[0].path);
      }
    }
  }, [currentItem]);

  const onSubmit = () => {
    setLoading(true);
    const _currentItem = { ...currentItem };
    if (currentItem.display) {
      _currentItem.display = '1';
    } else {
      _currentItem.display = '0';
    }
    if (currentItem?.keywords?.length > 0) {
      const _array = currentItem?.keywords.split('،');
      if (_array?.length === 0) {
        BSwalShowError(['لطفا کلمات کلیدی را با فرمت صحیح وارد کنید.']);
        setLoading(false);
        return;
      }
    } else {
      BSwalShowError(['لطفا کلمات کلیدی را با فرمت صحیح وارد کنید.']);
      setLoading(false);
      return;
    }
    delete _currentItem.attachments;
    delete _currentItem?.test;
    axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
    const formData = new FormData();
    for (let i = 0; i < Object.keys(_currentItem).length; i++) {
      formData.append(Object.keys(_currentItem)[i], Object.values(_currentItem)[i]);
    }
    if (id) {
      formData.append('_method', 'put');
    }
    axios({
      method: 'post',
      url: id ? 'blogs/'.concat(id) : 'blogs',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${cookies.get('userToken')}`,
      },
    })
      .then((res) => {
        if (res.data.data) {
          navigate('/cms/blogs');
        }
      })
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentItem, setCurrentItem);
  };

  const fileSelectedHandlerImage = async (e) => {
    const _currentSlider = currentItem;
    _currentSlider.image = null;
    setCoverImage(null);
    const file = e.target.files[0];
    // eslint-disable-next-line no-shadow
    _currentSlider.image = file;
    setCurrentItem(_currentSlider);
    const reader = new FileReader();
    const url = reader.readAsDataURL(file);
    reader.onloadend = () => {
      // eslint-disable-next-line no-shadow
      setCoverImage({ img: reader.result });
    };
  };

  useEffect(() => {
    if (textEditor !== '') {
      setCurrentItem({ ...currentItem, content: textEditor });
    }
  }, [textEditor]);

  return (
    <div style={{ margin: 10 }}>
      {currentItem && (
        <Card {...rest}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/cms/blogs',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'left', marginTop: '20px', marginLeft: '10px' }}
          >
            <ArrowLeftOutlined />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='اطلاعات وبلاگ' />
            <Divider />
            <CardContent>
              <br />
              <Grid container spacing={3}>
                <BTextField
                  sm={6}
                  xs={12}
                  label='عنوان وبلاگ'
                  name='name_fa'
                  value={currentItem?.name_fa}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.name_fa}
                  required
                />
                <BTextareaField
                  onChange={onChange}
                  name='description'
                  sm={6}
                  xs={12}
                  value={currentItem?.description}
                  label='خلاصه مطلب'
                  required
                />
                <BTextField
                  sm={6}
                  xs={12}
                  label='لینک وبلاگ به انگلیسی'
                  name='name'
                  value={currentItem?.name}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.name}
                  required
                  // {...register('name', { required: true })}
                />
                <BTextareaField
                  onChange={onChange}
                  name='keywords'
                  sm={6}
                  xs={12}
                  value={currentItem?.keywords}
                  label='کلمات کلیدی (کلامات کلیدی با ویرگول جدا شوند.)'
                  required
                />
                <div style={{ width: '100%', display: 'block', marginTop: '20px' }}>
                  <p style={{ marginTop: '20px' }}>محتوای وبلاگ</p>
                </div>
                <Grid item xs={12} style={{ direction: 'rtl' }}>
                  <CkeditorField
                    key={currentItem?.content ? `${String(id)}-loaded` : String(id)}
                    value={currentItem?.content}
                    onChange={(data) => setTextEditor(data)}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div style={{ fontSize: '16px' }}>انتخاب عکس بلاگ</div>
                  <span>
                    اندازه فایل آپلود شده حداکثر 1 مگابایت میباشد. فرمت عکس به صورت .webp یا jpeg/jpg یا png یا میباشد.
                  </span>
                  <br />
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .webp'
                    onChange={fileSelectedHandlerImage}
                    style={{ marginBottom: '15px', marginTop: '15px' }}
                  />
                  {coverImage?.img && (
                    <img src={coverImage.img} alt='cover' style={{ width: '200px', height: '200px' }} />
                  )}
                </Grid>
                <BCheckBoxField
                  sm={12}
                  name='display'
                  label='نمایش داده شود'
                  value={Number(currentItem?.display)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitClient' label='ذخیره اطلاعات' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/cms/blogs',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  بازگشت به لیست
                </Button>
              </Grid>
            </CardActions>
          </form>
        </Card>
      )}
    </div>
  );
};

export default BlogPage;
